module.exports = __webpack_public_path__ + "img/ellipse-check.52b87542.svg";